import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import TrackLabel from './TrackLabel';
const useStyles = makeStyles()({
    trackLabel: {
        zIndex: 3,
    },
    trackLabelOffset: {
        position: 'relative',
        display: 'inline-block',
    },
    trackLabelOverlap: {
        position: 'absolute',
    },
});
const TrackLabelContainer = observer(function ({ track, view, }) {
    const { classes, cx } = useStyles();
    const display = track.displays[0];
    const { trackLabel, trackLabelOverlap, trackLabelOffset } = classes;
    const labelStyle = view.trackLabelsSetting !== 'overlapping' || display.prefersOffset
        ? trackLabelOffset
        : trackLabelOverlap;
    return view.trackLabelsSetting !== 'hidden' ? (React.createElement(TrackLabel, { track: track, className: cx(trackLabel, labelStyle) })) : null;
});
export default TrackLabelContainer;
